import { Bank } from "./bank";
import { Rol } from "./rol";
export class User {
    id: string;
    username: string;
    name: string;
    surname: string;
    email: string;
    bank: Bank;
    rol: Rol;
    enabled: boolean = false;
    password: string;
    repeatPassword: string;
    cuit: boolean;
    patent: boolean;
    client: boolean;

    constructor(other?: User) {
        if (other) {
            this.id = other.id;
            this.username = other.username;
            this.name = other.name;
            this.surname = other.surname;
            this.email = other.email;
            this.bank = other.bank;
            this.rol = other.rol;
            this.enabled = other.enabled;
            this.cuit = other.cuit;
            this.patent = other.patent;
            this.client = other.client;
        }
    }

    isAdmin() {
        return (this.rol) ? this.rol.admin : false;
    }

    isClient() {
        return (this.rol) ? this.rol.client : false;
    }

    isPatent() {
        return this.patent;
    }

    isGaliciaBank() {
        return this.bank.name === 'BANCO GALICIA';
    }

    canViewSection(appSection: string) {
        if (this.isAdmin()) {
            return true;
        }
        if (this.rol.permissions) {
            let res = this.rol.permissions.filter(perm => perm.appSection.id === appSection);
            if (res.length > 0) {
                return res[0].visible;
            }
        }
        return false;
    }

    isActionAllowed(appSection: string, action: string, appSubSection: string) {
        if (this.isAdmin()) {
            return true;
        }
        if (this.rol.permissions) {
            let res = this.rol.permissions.filter(perm => perm.appSection.id === appSection);
            if (res.length > 0 && res[0].actions.length > 0) {
                let foundSection = res[0].actions.filter(act => act.action === action && act.appSection === appSubSection);
                if (foundSection.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/user.ts
 **/